import { Component, HostListener, ViewChild, Input, ElementRef, EventEmitter, Output, Renderer } from '@angular/core';
import { ViewController, AlertController, LoadingController, Events, NavController, ModalController } from 'ionic-angular';
import { EventServiceProvider } from '../../providers/event-service/event-service';
import { LoginService } from '../../providers/login-service/login-service';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { ManageAccountComponent } from '../../components/manage-account/manage-account';
import { CreateAppModal } from '../createapp-modal-popup/createapp-modal';
import { UserManagement } from '../user_management/user_management';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service'
import { WatchTabViewComponent } from '../../components/watch-tab-view/watch-tab-view';

const OBJLEN = 0;
const objLen = 0;
const mobileWidth = 1050;
@Component({
  selector: 'page-header',
  templateUrl: 'header.html',
})
export class HeaderPage {
  @Input() headerFull: any = false;
  boolHide: any = false;
  items: any = {};
  showAccountSettings: any = false;
  showIconList: any = false;
  newpasswordType_2: string;
  [x: string]: any;
  summaryData: any;
  email_id: any = '';
  old_password: any = '';
  new_password: any = '';
  con_password: any = '';
  passwordType: string = 'password';
  newpasswordType: string = 'password';
  passwordIcon1: string = 'eye-off';
  passwordIcon2: string = 'eye-off';
  resetPasswordCtrl: any;
  key: any;
  escape: any;
  betsy_page: boolean;
  side_menu: boolean;
  emailId: any;
  userName: any;
  isInitial: boolean = false;
  isImage: boolean = false;
  isInitialDesc: boolean = false;
  isImageDesc: boolean = false;
  profileImage: any = "";
  showSearchHeader: boolean = false;
  Header: boolean = true;
  showCreateAppbtn: boolean = false;
  showAppsMenuList: boolean = false;
  regUserId: any;
  betsypage: any;
  passData: any;
  overlayActive: boolean = false;
  screenWidth: any;
  mobileScreen: boolean = false;
  parentDateId: any = "";
  dateElem: any = "";
  objAccSummaryResult: any;
  extendAppStatus: boolean = false;
  app_code: any;
  app_icon: any;
  userSettingsMenu: boolean = false;
  broadcastSubs: any;
  manageAccScreen: boolean = false;
  @Output() pageContainer = new EventEmitter<any>();
  constructor(public elem: ElementRef, public navCtrl: NavController, public modalCtrl: ModalController,
    public loadingCtrl: LoadingController, private viewCtrl: ViewController, public events: Events, private eventObj: EventServiceProvider, private loginServ: LoginService, private popup: AlertController, public driveService: DriveServiceProvider, private EncrDecrService: EncrDecrServiceProvider, public configureAPIService: ConfigApiServiceProvider, public configureService: ConfigureServiceProvider, public communicationServ: CommunicationServiceProvider) {
    this.items = [
      {
        label: "Logout",
        icon: "log-out",
        show: this.loginServ.isReg(),
        action: () => { this.logout(); this.close(); }
      },
      {
        label: "Manage Account",
        icon: "cog",
        show: true,
        action: () => { this.openManageAccount(); this.close(); }
      },
      {
        label: "About",
        icon: "information-circle",
        show: true,
        action: () => { this.close(); alert("ePC Desk - alpha"); }
      }
    ]
    let loginUserDetail = this.driveService.objUserLoginDetails;
    let loginAdminId = loginUserDetail.email_id;
    this.emailId = loginAdminId;
    this.userName = this.emailId.substring(0, this.emailId.lastIndexOf("@"));
    this.driveService.longinUserName = this.userName;
    this.driveService.userInitial = this.userName.charAt(0).toUpperCase();
  }

  //****** MOBILE SCREEN ********//
  ngOnInit() {
    this.initDriveEvents();

    this.screenWidth = window.innerWidth;
    this.app_code = this.configureAPIService.currentDriveApp.app_code
    this.app_icon = this.configureAPIService.currentDriveApp.app_icon;
    this.appDetails = this.configureAPIService.currentDriveApp
    if (this.profileImage == null || this.profileImage == '' || this.profileImage == undefined) {
      this.isInitial = true;
      this.isImage = false;
      this.isInitialDesc = true;
      this.isImageDesc = false;
    } else {
      this.isImage = true;
      this.isInitial = false;
      this.isImageDesc = true;
      this.isInitialDesc = false;
    }

  }

  initDriveEvents() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "loginPage") {
          if (data.event === 'passRegUserId') {
            this.regUserId = data['data'];
          }
        }
        if (data.src === "createApp") {
          if (data.event === 'newApp') {
            this.openApp(0, data['data'])
          }
        }
      });
  }

  getAccSummaryData() {
    let pullSummaryData = {
      "email_id": this.emailId,
      "userid": this.configureService.getLoginUserID()
    }
    if (this.configureAPIService.driveApi.SummaryManageAcc != undefined) {
      var objData = Object.assign({}, this.configureAPIService.driveApi.SummaryManageAcc.params, pullSummaryData);
      this.configureAPIService.pullRequest(objData, this.submitSummerySucess);
    }
  }
  ngAfterViewInit() {
    if (this.configureAPIService.Tempalatestatus != '') {

      setTimeout(() => {
        this.driveService.broadcastInfo({ src: 'header', event: 'ExportFolder', exportfolderStatus: this.configureAPIService.Tempalatestatus, status: true });
      }, 1000)

    }
  }
  submitSummerySucess = ((data) => {
    console.log("pullSummaryData", data);
    let email_id_index = data.findIndex(element => element.EmailID == this.emailId);
    this.objAccSummaryResult = data[email_id_index];
    if (data != undefined && data.length != 0) {
      this.driveService.LoginUserDetails = data[0]
      this.profileImage = this.objAccSummaryResult != undefined && this.objAccSummaryResult["profile_image"] != null ? this.objAccSummaryResult["profile_image"] : this.profileImage;
    }
    if (this.manageAccScreen) {
      this.getManageAccScreen();
    }
  })

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'escape' || 'Esc') {
      if (this.showAccountSettings == true) {
        this.showAccountSettings = false;
      }
    }
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(event) {
    if (window.innerWidth < mobileWidth) {
      if (event.classList[0] == 'appLogo_container' || event.classList[0] == 'apps-icon' || event.classList[0] == 'moreApps' || event.textContent == 'All Apps') {
        this.showAppsMenuList = true;
        this.showAccountSettings = false;
      }
      else {
        this.showAppsMenuList = false;
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HeaderPage');
  }

  accountSettingsOpen() {
    if (!this.showAccountSettings) {
      this.showAccountSettings = true;
      this.overlayActive = true;
      this.userSettingsMenu = false;
      this.showAppsMenuList = false;
    } else {
      this.showAccountSettings = false;
      this.overlayActive = false;
    }
  }

  iconsOpen() {
    this.showIconList = !this.showIconList;
  }

  showSearchBar() {
    this.showSearchHeader = !this.showSearchHeader;
    this.Header = !this.Header;
  }

  onFocusOutEvent(event: any) {
    this.showSearchHeader = false;
    this.Header = true;
  }

  logout() {
    this.eventObj.trigEvent({ event: "epcDesk_CMD", data: { cmd: "logout" } });
    this.boolHide = this.loginServ.isReg()
    this.driveService.objCurrentFolder = this.driveService.getFolderStructure();
    this.driveService.objRootFolder = this.driveService.getFolderStructure();
  }

  openManageAccount() {
    this.manageAccScreen = true;
    if (Object.keys(this.driveService.LoginUserDetails).length == OBJLEN) {
      this.getAccSummaryData();
    } else {
      this.getManageAccScreen();
    }
  }

  getManageAccScreen() {
    this.showAccountSettings = false
    var modalPage = this.modalCtrl.create(ManageAccountComponent, { "accSummaryData": this.objAccSummaryResult }, { cssClass: "manage-account" });
    modalPage.present();
    modalPage.onDidDismiss(status => {
      this.manageAccScreen = false;
      if (status) {
        this.getAccSummaryData();
      }
    })
  }
  resetPassword() {
    this.resetPasswordCtrl = this.popup.create({
      title: 'Reset Password',
      cssClass: 'resetPassword_Main',
      inputs: [
        {
          name: 'emailID',
          placeholder: 'Email ID',
          id: 'emailId',
          type: 'email'
        },
        {
          name: 'oldPassword',
          placeholder: 'Old Password',
          type: 'password',
          id: 'oldPassword'
        },

        {
          name: 'newPassword',
          placeholder: 'New Password',
          type: 'password',
          id: 'newPassword'
        },
        {
          name: 'confirmPassword',
          placeholder: 'Confirm Password',
          type: 'password',
          id: 'confirmPassword'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');

          }
        },
        {
          text: 'Save',
          handler: data => {
            this.presentLoading();
            console.log('Save clicked');
            this.email_id = data.emailID;
            this.old_password = data.oldPassword;
            this.new_password = data.newPassword;
            this.con_password = data.confirmPassword;
            this.forgotPassword()
          }
        }
      ]
    });
    this.resetPasswordCtrl.present();
  }
  loader: any;
  presentLoading() {
    this.loader = this.loadingCtrl.create({
      content: "Please wait...",
    });
    this.loader.present();
  }
  forgotPassword() {
    if (this.email_id == "" || 0) {
      alert("Please Enter Email");
    } else if (this.old_password == "" || 0) {
      alert("Please Enter Old Password");
    } else if (this.new_password == "" || 0) {
      alert("Please Enter New Password");
    } else if (this.con_password == "" || 0) {
      alert("Please Enter Confirm Password");
    } else {
      this.proccessForgotPassword()
    }
  }

  proccessForgotPassword() {
    var old_password = this.EncrDecrService.set('BETSYENC123$$', this.old_password);
    var new_password = this.EncrDecrService.set('BETSYENC123$$', this.new_password);
    var confirm_password = this.EncrDecrService.set('BETSYENC123$$', this.con_password);

    let data = {};
    data = {
      "email": this.email_id,
      "Old_Password": old_password,
      "New_Password": new_password,
      "Confirm_Password": confirm_password,
      "userid": this.configureService.getLoginUserID(),
      "rptname": "Reps581",
      "client": "Master74634"
    }
    this.configureAPIService.pushRequest(data, this.forgotPasswordResponse);
    this.new_password = '';
    this.con_password = '';
  }

  forgotPasswordResponse = ((result) => {
    console.log(result["_POST_AddMethodResult"]);
    if (result == "SUCCESS") {
      this.resetPasswordCtrl.dismiss();
      let successAlert: any = '';
      successAlert = this.popup.create({
        title: 'Reset Success',
        subTitle: 'Reset Password successfully. You will be logged out from your account. Please, Login again.',
        buttons: [{
          text: 'Ok',
          handler: () => {
            console.log('Confirm Ok');
            this.loader.dismiss();
          }
        }]
      });

      successAlert.present();
      let __this: any = this;
      successAlert.onDidDismiss(function () {
        __this.logout();
      })
      this.resetPasswordCtrl.onDidDismiss(function () {
      });
    } else if (result.Result == "FAILED") {
      var pass_result = result.message;
      alert(pass_result);
      this.resetPassword();
    }
  })


  show_betsy_Page() {
    this.betsy_page = !this.betsy_page;
    this.driveService.broadcastInfo({ src: 'header', event: 'Hidepage', status: this.betsy_page });
  }


  close() {
    this.viewCtrl.dismiss().catch(() => { });
  }


  //New AppList Menu
  showAppsMenu(e) {
    if (!this.showAppsMenuList) {
      this.showAppsMenuList = true;
      this.overlayActive = true;
      this.userSettingsMenu = false;
      this.showAccountSettings = false;
    } else {
      this.showAppsMenuList = false;
      this.overlayActive = false;
    }

    if (this.mobileScreen == true) {
      this.extendAppStatus = true;
      this.overlayActive = true;
    } else {
      this.extendAppStatus = false;
      this.overlayActive = false;
    }
  }

  expandAllApps() {
    this.extendAppStatus = !this.extendAppStatus;
  }

  openApp(e, appInfo) {
    if (Object.keys(this.driveService.appSpace).length != 0) {
      this.driveService.appSpace = {};
    }
    this.driveService.openDrive(appInfo, (rootFolder) => {
      this.driveService.gotoFolder(null);
      this.driveService.listUsersAssignedToEpc();
      this.app_code = appInfo.app_code;
      this.app_icon = appInfo.app_icon;
      this.appDetails = appInfo;
      const CLIENT_ADMIN = 1;
      this.driveService.clientAdminAccess = appInfo.user_access_type == CLIENT_ADMIN ? true : false;
      let studioIdx = this.driveService.pages.findIndex(page => page.id == 'Templates');
      this.driveService.pages[studioIdx]['display'] = this.driveService.clientAdminAccess;
      this.driveService.current_app_name = appInfo['app_name']
      this.driveService.broadcastInfo({ src: 'main', event: 'showListView', data: false });
      this.driveService.broadcastInfo({ src: 'main', event: 'loadPageComponent', page: 'Drive', status: true });
      this.driveService.broadcastInfo({ src: 'main', event: 'showTemplates', status: true });
      this.showAppsMenuList = false;
      this.overlayActive = false;
    });
  }

  hideAppMenu(e) {
    this.showAppsMenuList = false;
    this.overlayActive = false;
    this.userSettingsMenu = false;
    this.showAccountSettings = false;
  }

  openCreateApp() {
    let myModal = this.modalCtrl.create(CreateAppModal);
    myModal.onDidDismiss(data => {
      console.log(data);
    })
    myModal.present();

  }

  openUserSetting() {
    if (!this.userSettingsMenu) {
      this.userSettingsMenu = true;
      this.overlayActive = true;
      this.showAppsMenuList = false;
      this.showAccountSettings = false;
    } else {
      this.userSettingsMenu = false;
      this.overlayActive = false;
    }
  }

  openUserManagement() {
    let modal = this.modalCtrl.create(UserManagement);
    modal.present();
  }

  openWatchTab() {
    this.showAccountSettings = false;
    this.showAppsMenuList = false;
    let modal = this.modalCtrl.create(WatchTabViewComponent);
    modal.present();
  }

  appManagement() {
    let modal = this.modalCtrl.create(CreateAppModal, { "appDetail": this.appDetails, "status": "Edit" });
    modal.present();
  }

  export() {
    this.driveService.broadcastInfo({ src: 'header', event: 'ExportFolder', exportfolderStatus: this.configureAPIService.Tempalatestatus, status: true });
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/header/header.ts